module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_vm._v("\n  Episode screens and information provided by\n  "), _c('a', {
    attrs: {
      "href": "http://thetvdb.com/"
    }
  }, [_vm._v("The TVDB")]), _vm._v(".  Please help them by\n  contibuting.\n")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-badc7e0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
// module id = 44
// module chunks = 0